export const USERS_ROUTES = {
  LIST: '/usuarios',
  NEW: '/usuarios/novo',
  DETAIL_PATTERN: '/usuarios/:id',
  detail: (id: string) => `/usuarios/${id}`,
} as const;

export const USERS_ENDPOINTS = {
  LIST: '/api/v1/users',
  detail: (id: string) => `/api/v1/users/${id}`,
} as const;

export const USERS_QUERY_KEYS = {
  all: ['users'] as const,
  list: (page: number, perPage: number, search: string, status: string) =>
    ['users', 'list', page, perPage, search, status] as const,
  detail: (id: string) => ['users', 'detail', id] as const,
};

export const USER_STATUS_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'active', label: 'Ativos' },
  { value: 'inactive', label: 'Inativos' },
] as const;

export type UserStatusFilter = (typeof USER_STATUS_OPTIONS)[number]['value'];
